module.exports = __webpack_public_path__ + "static/assets/e7e4f417c6bff27ca7b211c1583ff3f4.svg";